import { render, staticRenderFns } from "./MessageList.vue?vue&type=template&id=56b0e6a8&scoped=true"
import script from "./MessageList.vue?vue&type=script&lang=js"
export * from "./MessageList.vue?vue&type=script&lang=js"
import style0 from "./MessageList.vue?vue&type=style&index=0&id=56b0e6a8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b0e6a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\androidcode\\zf_tms_vue\\tms_vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56b0e6a8')) {
      api.createRecord('56b0e6a8', component.options)
    } else {
      api.reload('56b0e6a8', component.options)
    }
    module.hot.accept("./MessageList.vue?vue&type=template&id=56b0e6a8&scoped=true", function () {
      api.rerender('56b0e6a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/MessageList.vue"
export default component.exports